/* DillySocks — Bild-Priorisierung im Produktraster (Sean 12.08.2026).

   Problem: Horizon laedt ALLE ersten Kartenbilder des Rasters eager
   (section.index < 5 in card-gallery.liquid). Beim Seitenaufbau starten
   also 24+ Downloads gleichzeitig; der Browser stuft unsichtbare Bilder
   als unwichtig ein und laedt sie zuletzt — beim Scrollen wirken die
   Karten dadurch verzoegert ("graue Karten, Bild ploppt nach").

   Loesung:
   1. Die ersten Karten (above the fold) bekommen fetchpriority=high —
      sie gewinnen den Kampf um die Bandbreite und stehen sofort.
   2. Alle weiteren Karten werden beobachtet: 1200px BEVOR sie sichtbar
      werden, wird ihr Bild hochpriorisiert (und ggf. von lazy auf eager
      gestellt). So ist das Bild in der Regel fertig, wenn die Karte in
      den Viewport scrollt.
   3. Nachgeladene Karten (Pagination/Infinite Scroll) werden per
      MutationObserver genauso behandelt. */
(function () {
  'use strict';

  var FOLD_COUNT = 6; /* ~erste Rasterreihe Desktop, 3 Reihen Mobile */

  function firstImg(card) {
    return card.querySelector('.card-gallery img');
  }

  function boost(img) {
    if (!img || img.complete) return;
    img.fetchPriority = 'high';
    img.setAttribute('fetchpriority', 'high');
    if (img.loading === 'lazy') img.loading = 'eager';
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          boost(firstImg(e.target));
          io.unobserve(e.target);
        });
      },
      /* root:null = Browser-Viewport — funktioniert auch, wenn (wie bei
         Horizon Desktop) ein innerer Container scrollt statt window */
      { rootMargin: '1200px 0px' }
    );
  }

  function handle(card) {
    if (card.dataset.dsImgPrio) return;
    card.dataset.dsImgPrio = '1';
    if (io) io.observe(card);
  }

  function scan() {
    var cards = document.querySelectorAll('.product-grid .product-card');
    for (var i = 0; i < cards.length; i++) {
      if (i < FOLD_COUNT) {
        boost(firstImg(cards[i]));
        cards[i].dataset.dsImgPrio = '1';
      } else {
        handle(cards[i]);
      }
    }
  }

  function init() {
    scan();
    /* Pagination / nachgeladene Produkte */
    if ('MutationObserver' in window) {
      new MutationObserver(function () { scan(); }).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
